import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import _ from 'lodash';
import { openSnackbar } from 'helpers/Notifier';
import { httpStatusEnum, TE } from 'appconstants';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { bindLogger } from 'helpers/BindLogger';
import { openConfirmation } from 'helpers/Confirmation';
import EditRegSteps from './EditRegSteps';
import { RegStepsColumns } from '../gridcolumns';

let setEditingStep;
const RegStepsComp = (props) => {
  const {
    data, saveRegSteps, state, setState, onRowClicked, editPermission, setIsDisableEditButton
  } = props;

  const RenderEditRow = (row, setEditing) => {
    if (_.isEmpty(state) && !_.isEqual(row, state)) {
      setState({ ...row });
    }

    setEditingStep = (flg) => {
      setEditing(flg);
      setState({});
    };
    return (
      <EditRegSteps
        state={state || row}
        setEditing={setEditing}
        setState={setState}
        defaultRow={row}
        setIsDisableEditButton={setIsDisableEditButton}
      />
    );
  };

  const saveRegStep = () => {
    saveRegSteps(state);
  };

  return (
    <ValidatorForm onSubmit={saveRegStep}>
      <GridTable
        tag={`${TE.ID}regsteps${TE.TABLE}`}
        title="Registration Steps"
        exportTitle={`Registration Steps-${useGetPathProtocol()}-OPEN Setup`}
        id="registrationSteps"
        columns={RegStepsColumns}
        user={GetUserFullName()}
        rows={data}
        editable
        editMode={editPermission}
        // deletable={deletePermission}
        allowAddRow={editPermission}
        filterable
        sortable
        // onDelete={DeleteRow}
        enableToolbar
        renderEditRow={RenderEditRow}
        rowEditable={() => true}
        // rowDeletable={() => true}
        onRowClicked={onRowClicked}
        toPdf={false}
      />
    </ValidatorForm>
  );
};


const RegSteps = compose(
  withAppContext,
  withState('state', 'setState', {}),
  withHandlers({
    saveRegSteps: props => postBody => {
      const {
        onSave, context, protocolId, data
      } = props;
      const postObj = { ...postBody, prtId: protocolId, isLoadToCaaers: !!postBody.isLoadToCaaers };
      // PROT-158 convert null to bool
      postObj.isSlot = !!postObj.isSlot;

      postObj.minNonReqCred = postObj.minNonReqCred || '0';
      postObj.maxNonReqCred = postBody.maxNonReqCred || '0';
      //
      postObj.minNonReqCred = parseInt(postObj.minNonReqCred, 10);
      postObj.maxNonReqCred = parseInt(postObj.maxNonReqCred, 10);

      const activeRecords = postBody?.protStepRtfSetups?.reduce((prev, curr) => {
        return curr.esysStatus === 'ACTIVE' ? prev + 1 : prev
      }, 0) || 0;

      if (postObj.minNonReqCred > activeRecords) {
        openSnackbar({
          message: 'Minimum Non-required credentials value cannot exceed the total number of active non-required credentials included in the OPEN IRTF Provider Setup grid.',
          variant: 'success',
          name: 'reg_steps'
        });
        return;
      }
      
      if(postObj.maxNonReqCred > activeRecords) {
        openSnackbar({
          message: 'Maximum Non-required credentials value cannot exceed the total number of active non-required credentials included in the OPEN IRTF Provider Setup grid.',
          variant: 'success',
          name: 'reg_steps'
        });
        return;
      }
      
      const confirmSave = () => {
        const payload = _.omit(postObj, ['protStepRtfSetups', 'fromCred']);
        bindLogger(onSave, context)(payload, protocolId).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_REG_STEPS_SUCCESS'),
              variant: 'success',
              name: 'reg_steps'
            });
            setEditingStep(false);
          }
        });
      };

      const index = data.findIndex(f => f.isLoadToCaaers && !f.endDate && f.prlId !== postBody.prlId);


      let confirmationOptions = {
        message: GetFromCtxValue(context, 'PROTOCOL_REG_STEPS_CONFIRM'),
        onAction: confirmSave,
        name: 'reg_steps'
      };
      if (postBody.isLoadToCaaers && index !== -1) {
         confirmationOptions = {
          title: 'Confirm Change in caAERS Load Step',
          message: `Multiple steps cannot be YES for caAERS Load?`,
          name: 'reg_steps',
          hideButton2: true,
          onAction: () => null // close the modal
        };
      }
      openConfirmation(confirmationOptions);
    }
  })

)(RegStepsComp);

export default RegSteps;
